export const TEST_IDS = {
  issueBody: 'issue-body',
  bodyLoading: 'body-loading',
  commentBox: (postFix = '') => `markdown-editor-${postFix}`,
  projectTitle: 'project-title',
}
